import MuiPaper from '@mui/material/Paper';
import { styled } from '@mui/material';

export const PageSection = styled(MuiPaper)(() => ({
  borderRadius: '2px',
  boxShadow: ' 0px 2px 5px 2px rgba(0, 0, 0, 0.05)',
  padding: '24px',
  '& .MuiDivider-fullWidth': {
    margin: '16px -24px',
  },
}));
